export default "__VITE_ASSET__3IB229RJ__"